import React from 'react'
import cn from 'classnames'
import { Image } from '../../ui-lib/image'
import { ResponsiveImageProps } from './types'
import { generateImgAttrs } from './utils'
import styles from './responsive-image.module.scss'

const assetLoader = ({ src, width }: { src: string; width?: number }) => {
  return `${src}?${width ? `w=${width}` : ''}&fm=webp`
}

const fallbackAssetLoader = ({ src, width }: { src: string; width?: number }) => {
  return `${src}?${width ? `w=${width}` : ''}`
}

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  alt = '',
  src,
  width,
  height,
  sizes,
  layout = 'intrinsic',
  className,
  fetchpriority,
  loading,
}) => {
  const { srcSet, sizes: generatedSizes } = generateImgAttrs({ src, width, sizes, loader: assetLoader })

  const {
    srcSet: fallbackSrcSet,
    sizes: fallbackSizes,
    src: fallbackSrc,
  } = generateImgAttrs({ src, width, sizes, loader: fallbackAssetLoader })

  return (
    <div className={cn(layout === 'responsive' && styles.responsiveImgContainer)}>
      <picture>
        <source srcSet={srcSet} type="image/webp" sizes={generatedSizes} />
        <source srcSet={fallbackSrcSet} sizes={fallbackSizes} />
        <Image
          src={fallbackSrc}
          alt={alt}
          className={className}
          width={width}
          height={height}
          loading={loading}
          fetchpriority={fetchpriority}
        />
      </picture>
    </div>
  )
}
